var map = {
	"./gallery-wip-pommel-cap_00.jpg": 2813,
	"./gallery-wip-pommel-cap_01.jpg": 2814,
	"./gallery-wip-pommel-cap_02.jpg": 2815,
	"./gallery-wip-pommel-cap_03.jpg": 2816,
	"./gallery-wip-pommel-cap_04.jpg": 2817,
	"./gallery-wip-pommel-cap_05.jpg": 2818,
	"./gallery-wip-pommel-cap_06.jpg": 2819,
	"./gallery_00.jpg": 2820,
	"./gallery_01.jpg": 2821,
	"./gallery_02.jpg": 2822,
	"./gallery_03.jpg": 2823,
	"./gallery_04.jpg": 2824,
	"./gallery_05.jpg": 2825,
	"./gallery_06.jpg": 2826
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2812;